export const deduplicateSlots = (slots)=>{
    if (!slots) {
        return undefined;
    }
    const seen = new Set();
    return slots.filter((entry)=>{
        const key = `${entry.slot?.startDate}_${entry.slot?.endDate}`;
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
};

//# sourceMappingURL=deduplicate-slots.js.map